module.exports = __webpack_public_path__ + "img/message-3.92daf214.png";